import * as types from './mutation-types'
import Ls from "@/services/ls";

export default {
    [types.LOAD_RESTAURANT] (state, data) {
        state.restaurant = data
    },

    [types.SAVE_RESTAURANT] (state) {
        Ls.set('restaurant', JSON.stringify(state.restaurant))
    },
}

